import { store } from '../store';

export const SET_ISFETCHING = 'SET_ISFETCHING';
export const SET_ISBLOCKING = 'SET_ISBLOCKING';
export const SET_ROLE_PERMISSIONS = 'SET_ROLE_PERMISSIONS';
export const CONFIG_STATUS_SUCCESS = 'CONFIG_STATUS_SUCCESS';
export const SHIFT_TYPE_SUCCESS = 'SHIFT_TYPE_SUCCESS';
export const CUSTOMER_DROP_DOWN_SUCCESS = 'CUSTOMER_DROP_DOWN_SUCCESS';
export const TIMESHEET_DROP_DOWN_SUCCESS = 'TIMESHEET_DROP_DOWN_SUCCESS';
export const SHIFT_TIME_TYPE_SUCCESS = 'SHIFT_TIME_TYPE_SUCCESS';
export const PAY_RATE_OVERRIDE_SUCCESS = 'PAY_RATE_OVERRIDE_SUCCESS';

export const REMEMBER_GF_ALL_TIMESHEET_FILTER = 'REMEMBER_GF_ALL_TIMESHEET_FILTER';
export const REMEMBER_GF_BILLABLE_TIMESHEET_FILTER = 'REMEMBER_GF_BILLABLE_TIMESHEET_FILTER';
export const REMEMBER_GF_ALL_TIMESHEET_TABLE_FILTER = 'REMEMBER_GF_ALL_TIMESHEET_TABLE_FILTER';
export const REMEMBER_AWAITING_CUSTOMER_APPROVAL_FILTER =
  'REMEMBER_AWAITING_CUSTOMER_APPROVAL_FILTER';
export const REMEMBER_READY_TO_INVOICE_FILTER = 'REMEMBER_READY_TO_INVOICE_FILTER';
export const REMEMBER_CORPORATE_ALL_TIMESHEET_FILTER = 'REMEMBER_CORPORATE_ALL_TIMESHEET_FILTER';
export const SET_NOTIFICATIONS = 'SET_NOTIFICATIONS';
export const SET_CONNECTION_STATUS = 'SET_CONNECTION_STATUS';
export const SET_RECENT_NOTIFICATION = 'SET_RECENT_NOTIFICATION';
export const REMEMBER_EXECUTIVE_DASHBOARD_FILTER = 'REMEMBER_EXECUTIVE_DASHBOARD_FILTER';
export const REMEMBER_ACTIONABLE_TIMESHEET_FILTER = 'REMEMBER_ACTIONABLE_TIMESHEET_FILTER';
export const REMEMBER_EXCEPTION_TIMESHEET_FILTER = 'REMEMBER_EXCEPTION_TIMESHEET_FILTER';

export const SET_HOLLIDAY_LIST = 'SET_HOLLIDAY_LIST';
export const SET_DISPLAY_BANNER = 'SET_DISPLAY_BANNER';

export const SET_MY_SPACE = 'SET_MY_SPACE';
export const SET_ACTIVE_USERS_COUNT = 'SET_ACTIVE_USERS_COUNT';

export const SET_SHOW_SIDE_LIST = 'SET_SHOW_SIDE_LIST';
export const STATE_LIST_SUCCESS = 'STATE_LIST_SUCCESS';
export const UKG_ROLES_SUCCESS = 'UKG_ROLES_SUCCESS';
export const COMPANY_LIST_SUCCESS = 'COMPANY_LIST_SUCCESS';
export const AUTOMATION_TYPES_SUCCESS = 'AUTOMATION_TYPES_SUCCESS';

export const startFetching = () => ({
  type: SET_ISFETCHING,
  payload: true,
});

export const startBlocking = () => ({
  type: SET_ISBLOCKING,
  payload: true,
});

export const stopFetching = () => ({
  type: SET_ISFETCHING,
  payload: false,
});

export const stopBlocking = () => ({
  type: SET_ISBLOCKING,
  payload: false,
});

export const setMySpace = (payload: any) => ({
  type: 'SET_MY_SPACE',
  payload,
});

export const setRolePermissionsSuccess = (payload: any) => ({
  type: SET_ROLE_PERMISSIONS,
  payload,
});

export const GetConfigStatusSuccess = (payload: any) => ({
  type: CONFIG_STATUS_SUCCESS,
  payload,
});

export const GetShiftTypeSuccess = (payload: any) => ({
  type: SHIFT_TYPE_SUCCESS,
  payload,
});

export const GetCustomerDropDownSuccess = (payload: any) => ({
  type: CUSTOMER_DROP_DOWN_SUCCESS,
  payload,
});

export const GetTimeSheetDropDownSuccess = (payload: any) => ({
  type: TIMESHEET_DROP_DOWN_SUCCESS,
  payload,
});

export const GetShiftTimeTypeSuccess = (payload: any) => ({
  type: SHIFT_TIME_TYPE_SUCCESS,
  payload,
});

export const GetPayrateOverrideSuccess = (payload: any) => ({
  type: PAY_RATE_OVERRIDE_SUCCESS,
  payload,
});

export const RememberGFAllTimesheetFilters = (payload: any) => {
  const user_id = store.getState().commonReducer.rolePermissions.id;
  sessionStorage.setItem(`all_timesheet_filter_${user_id}`, JSON.stringify(payload));
  return {
    type: REMEMBER_GF_ALL_TIMESHEET_FILTER,
    payload,
  };
};

export const RememberGFBillableTimesheetFilters = (payload: any) => {
  const user_id = store.getState().commonReducer.rolePermissions.id;
  sessionStorage.setItem(`billable_timesheet_filter_${user_id}`, JSON.stringify(payload));
  return {
    type: REMEMBER_GF_BILLABLE_TIMESHEET_FILTER,
    payload,
  };
};

export const RememberTimesheetTableFilters = (payload: any, tableId: string) => {
  const user_id = store.getState().commonReducer.rolePermissions.id;
  sessionStorage.setItem(`${tableId}_${user_id}`, JSON.stringify(payload));
  // return {
  //   type: tableId,
  //   payload,
  // };
};

export const GetTimesheetTableFilters = (tableId: string) => {
  const user_id = store.getState().commonReducer.rolePermissions.id;
  const tableFilters = sessionStorage.getItem(`${tableId}_${user_id}`);
  return tableFilters;
  // tableFilters && store.dispatch(RememberGFAllTimesheetFilters(JSON.parse(tableFilters as string)));
};

export const RememberAwaitingCustomerApprovalFilters = (payload: any) => {
  const user_id = store.getState().commonReducer.rolePermissions.id;
  sessionStorage.setItem(`awaiting_customer_approval_filter_${user_id}`, JSON.stringify(payload));
  return {
    type: REMEMBER_AWAITING_CUSTOMER_APPROVAL_FILTER,
    payload,
  };
};

export const RememberReadyToInvoiceFilters = (payload: any) => {
  const user_id = store.getState().commonReducer.rolePermissions.id;
  sessionStorage.setItem(`ready_to_invoice_filter_${user_id}`, JSON.stringify(payload));
  return {
    type: REMEMBER_READY_TO_INVOICE_FILTER,
    payload,
  };
};

export const RememberCorporateAllTimesheetFilters = (payload: any) => {
  const user_id = store.getState().commonReducer.rolePermissions.id;
  sessionStorage.setItem(`corporate_all_timesheet_filter_${user_id}`, JSON.stringify(payload));
  return {
    type: REMEMBER_CORPORATE_ALL_TIMESHEET_FILTER,
    payload,
  };
};

export const SetNotifications = (payload: any) => {
  const user_id = store.getState().commonReducer.rolePermissions.id;
  sessionStorage.setItem(`notifications_${user_id}`, JSON.stringify(payload));
  return {
    type: SET_NOTIFICATIONS,
    payload,
  };
};

export const SetConnectionStatus = (payload: any) => {
  return {
    type: SET_CONNECTION_STATUS,
    payload,
  };
};

export const SetRecentNotification = (payload: any) => {
  return {
    type: SET_RECENT_NOTIFICATION,
    payload,
  };
};
export const RememberExecutiveDashboardFilters = (payload: any) => {
  const user_id = store.getState().commonReducer.rolePermissions.id;
  sessionStorage.setItem(`executive_filter_${user_id}`, JSON.stringify(payload));
  return {
    type: REMEMBER_EXECUTIVE_DASHBOARD_FILTER,
    payload,
  };
};
export const RememberActionableTimesheetFilters = (payload: any) => {
  const user_id = store.getState().commonReducer.rolePermissions.id;
  sessionStorage.setItem(`actionable_timesheet_filter_${user_id}`, JSON.stringify(payload));
  return {
    type: REMEMBER_ACTIONABLE_TIMESHEET_FILTER,
    payload,
  };
};

export const RemembeExceptionTimesheetFilters = (payload: any) => {
  const user_id = store.getState().commonReducer.rolePermissions.id;
  sessionStorage.setItem(`exception_timesheet_filter_${user_id}`, JSON.stringify(payload));
  return {
    type: REMEMBER_EXCEPTION_TIMESHEET_FILTER,
    payload,
  };
};

export const setHolidayList = (list: boolean) => {
  return {
    type: SET_HOLLIDAY_LIST,
    payload: list,
  };
};
export const SetActiveUsersCount = (payload: number) => ({
  type: SET_ACTIVE_USERS_COUNT,
  payload,
});
export const setDisplayBanner = (payload: any) => {
  localStorage.setItem('displayBanner', payload);
  return {
    type: SET_DISPLAY_BANNER,
    payload,
  };
};

export const setShowSideList = (value: boolean) => ({
  type: 'SET_SHOW_SIDE_LIST',
  payload: value,
});
export const setStateListSuccess = (payload: any) => ({
  type: STATE_LIST_SUCCESS,
  payload,
});
export const setUkgRolesSuccess = (payload: any) => ({
  type: UKG_ROLES_SUCCESS,
  payload,
});
export const setCompanyListSuccess = (payload: any) => ({
  type: COMPANY_LIST_SUCCESS,
  payload,
});
export const SET_CROSS_COMPANY_ACCESS_ERROR = 'SET_CROSS_COMPANY_ACCESS_ERROR';

export const setCrossCompanyAccessError = (value: boolean) => ({
  type: SET_CROSS_COMPANY_ACCESS_ERROR,
  payload: value,
});

export const GetAutomationTypes = (payload: any) => ({
  type: AUTOMATION_TYPES_SUCCESS,
  payload,
});
